import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	attachmentContent: {
		id: 'contextual-summary.gadgets.activity-feed.activity-items.attachment-added.attachment-content',
		defaultMessage: '{author} attached a file to {issueLink}',
		description:
			'Message shape for an activity item describing an attachment being added to an issue. "author" will be the name of the user that actioned the activity as a hyperlink to their profile, while "issueLink" will be a smart link to the modified issue.',
	},
});
